import { Clock, Users, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useLang } from '../contexts/LanguageContext';
import { useData } from '../contexts/DataContext';

export default function Excursions() {
  const { excursions, loading } = useData();
  const { t, lang } = useLang();

  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  if (loading) {
    return (
      <section className="py-24 bg-[#0A192F]">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="animate-pulse text-slate-400">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="excursions" className="py-24 bg-[#0A192F]" data-testid="excursions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-cyan-400 text-sm uppercase tracking-[0.2em] mb-4 font-semibold">{t('exc_label')}</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight mb-6">
            {t('exc_title_1')} <span className="gradient-text">{t('exc_title_2')}</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">{t('exc_desc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {excursions.map((excursion, index) => (
            <div key={excursion.id} className="premium-card card-hover group overflow-hidden" data-testid={`excursion-card-${index}`}>
              <div className="relative h-56 overflow-hidden">
                <img src={excursion.image_url} alt={excursion.name} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#112240] to-transparent" />
                <div className="absolute top-4 right-4 bg-gradient-to-r from-orange-600 to-yellow-500 text-black font-bold px-4 py-2 rounded-full">
                  ${excursion.price} USD
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors">
                  {lang === 'es' ? (excursion.name_es || excursion.name) : excursion.name}
                </h3>
                <p className="text-slate-400 mb-4 line-clamp-2">
                  {lang === 'es' ? (excursion.description_es || excursion.description) : excursion.description}
                </p>
                <div className="flex items-center gap-4 mb-6 text-sm text-slate-500">
                  {excursion.duration && (
                    <div className="flex items-center gap-1">
                      <Clock className="w-4 h-4 text-cyan-400" />
                      <span>{excursion.duration}</span>
                    </div>
                  )}
                  <div className="flex items-center gap-1">
                    <Users className="w-4 h-4 text-orange-400" />
                    <span>{t('exc_all_groups')}</span>
                  </div>
                </div>
                <Button className="w-full bg-gradient-to-r from-orange-600 to-yellow-500 text-black font-bold uppercase tracking-wide hover:brightness-110 transition-all"
                  onClick={scrollToBooking} data-testid={`excursion-book-${index}`}>
                  {t('exc_book')}
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
